import API from "./axiosConfig";

export const getAgentsForFilter = async (data) => {
  try {
    const response = await API.get("/agents-for-filter", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogs = async (data) => {
  try {
    const response = await API.get("/logs", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

